import { Observable } from 'rxjs';
import { ApiResponse, Filter, PaginationData } from '../pagination/models';

export interface Subaccount {
    id: number;
    account: string;
    description: string;
    need_third: boolean;
    is_tax: boolean;
    // Add other fields as needed
}

export interface UpdateSubaccountDto {
    description?: string;
    need_third?: boolean;
    is_tax?: boolean;
}

export abstract class SubaccountsRepository {
    abstract getSubaccounts(page: number, limit: number, filters: Filter[]): Observable<ApiResponse<PaginationData<Subaccount[]>>>;
    abstract updateSubaccount(id: number, data: UpdateSubaccountDto): Observable<ApiResponse<Subaccount>>;
    abstract deleteSubaccount(id: number): Observable<ApiResponse<void>>;
}
